import { api } from "../api_middleware";
import { getEffectiveBaseMediaUrl } from "../utils/serverUrls";
import {
  getHttpUrl,
  getEffectiveEnvironment,
  getLocalEnvOverride,
  getForcePortOverride,
} from "../utils/serverUrls";

export interface LinearFeedbackRequest {
  session_id: string;
  conversation_id: string;
  comment: string;
}

export interface APISelectorEntry {
  title: string;
  subtitle?: string;
  res_link_params_id: string;
}

export interface APISelector {
  selector_id: string;
  organization_id: string;
  pre_selection_copy?: string;
  selector_title?: string;
  selector_subtitle?: string;
  entries: APISelectorEntry[];
}

export const sendLinearFeedback = async (sessionId: string, conversationId: string, comment: string): Promise<void> => {
  const sendFeedbackRequest: LinearFeedbackRequest = {
    session_id: sessionId,
    conversation_id: conversationId,
    comment: comment,
  };
  await api(
    "v1/api/feedback",
    "POST",
    getEffectiveBaseMediaUrl(),
    sendFeedbackRequest
  );
};

export const getSelector = async (selectorId: string): Promise<APISelector | null> => {
  const baseUrl = getHttpUrl(
    getEffectiveEnvironment("PRODUCTION"),
    getLocalEnvOverride() ?? undefined,
    getForcePortOverride() ?? undefined,
    undefined
  );
  console.log("getSelector starting:", selectorId, baseUrl);
  const response = await api(
    `v1/pixels/selectors/${selectorId}`,
    "GET",
    baseUrl
  );
  console.log("getSelector response:", response);
  return response;
};